// material
import { Box, BoxProps } from "@mui/material"

// ----------------------------------------------------------------------

export default function Logo({ sx }: BoxProps) {
  return <Box component="img" src="/logo.png" sx={{ width: 60, height: "auto", ...sx }} />
}
